import React, { useState, useEffect } from 'react';
import Breadcumb from '../../Layouts/Breadcumb'
import { Grid, TextField } from '@mui/material'
import DashboardNav from './DashboardNav'
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Searchcategory from '../Home/HomeSearch/Searchcategory';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { jwtDecode } from 'jwt-decode'; // Corrected import
import { Constants } from '../../endPoints';

export default function Editproduct() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [content, setContent] = useState('');
  const [selections, setSelections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shopForOptions, setShopForOptions] = useState([]);
  const [selectedSelection, setSelectedSelection] = useState(null); // New state to hold selected selection
  const [isSelectionLoading, setIsSelectionLoading] = useState(false);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  const [isShopForLoading, setIsShopForLoading] = useState(false);


  const [ringStyles, setRingStyles] = useState([]);
  const [isRingStylesLoading, setIsRingStylesLoading] = useState(false);

  const [clarityOptions, setClarityOptions] = useState([]);
  const [isClarityLoading, setIsClarityLoading] = useState(false);

  const [stoneColors, setStoneColors] = useState([]);
  const [isStoneColorsLoading, setIsStoneColorsLoading] = useState(false);

  const [pearlColors, setPearlColors] = useState([]);
  const [isPearlColorsLoading, setIsPearlColorsLoading] = useState(false);

  const [pearlTypes, setPearlTypes] = useState([]);
  const [isPearlTypesLoading, setIsPearlTypesLoading] = useState(false);

  const [diamondColors, setDiamondColors] = useState([]);
  const [isDiamondColorsLoading, setIsDiamondColorsLoading] = useState(false);

  const [imagePreviews, setImagePreviews] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [resetKey, setResetKey] = useState(0);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${Constants.getProductById}/${id}`);
        console.log('Product fetch response:', response); // Log the response
        if (response.data.success === 1) {
          setProduct(response.data.data); // Set product data
          // console.log('Fetched product:', response.data.data); // Log the product data
        } else {
          console.log('Product fetch failed:', response.data); // Log the error in case of failure
        }
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    };

    fetchProduct();
  }, [id]);

  useEffect(() => {
    if (feedbackMessage) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [feedbackMessage]);


  useEffect(() => {
    const fetchProductImages = async () => {
      setIsImageLoading(true);
      try {
        const response = await axios.get(`${Constants.getProductImagesById}/${id}`);
        if (response.data.status === 1) {
          setProductImages(response.data.data); // Set product images
        }
      } catch (error) {
        console.error('Error fetching product images:', error);
      } finally {
        setIsImageLoading(false);
      }
    };

    if (id) {
      fetchProductImages(); // Fetch images when product ID is available
    }
  }, [id]);


  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    fetchCountries();
  }, []);

  const fetchStates = async (countryId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getStatecountryById}/${countryId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setStates(response.data.data);
      setCities([]); // Clear cities when country changes
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchCities = async (stateId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getCityStateById}/${stateId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setCities(response.data.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  useEffect(() => {
    const fetchSelections = async () => {
      setIsSelectionLoading(true);
      try {
        const response = await axios.get(Constants.listSelection);
        if (response.data.status === 1) {
          setSelections(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching selections:', error);
      } finally {
        setIsSelectionLoading(false);
      }
    };

    fetchSelections();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsCategoriesLoading(true);
      try {
        const response = await axios.get(Constants.listCategory);
        if (response.data.status === 1) {
          setCategories(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setIsCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchShopForOptions = async () => {
      setIsShopForLoading(true);
      try {
        const response = await axios.get(Constants.listShopFor);
        if (response.data.status === 1) {
          setShopForOptions(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching shopFor options:', error);
      } finally {
        setIsShopForLoading(false);
      }
    };

    fetchShopForOptions();
  }, []);


  useEffect(() => {
    const fetchRingStyles = async () => {
      setIsRingStylesLoading(true);
      try {
        const response = await axios.get(Constants.listRingStyle);
        if (response.data.status === 1) {
          setRingStyles(response.data.list); // Set ring styles options
        }
      } catch (error) {
        console.error('Error fetching ring styles:', error);
      } finally {
        setIsRingStylesLoading(false);
      }
    };

    fetchRingStyles();
  }, []);

  useEffect(() => {
    const fetchClarityOptions = async () => {
      setIsClarityLoading(true);
      try {
        const response = await axios.get(Constants.listClarity);
        if (response.data.status === 1) {
          setClarityOptions(response.data.list); // Set clarity options
        }
      } catch (error) {
        console.error('Error fetching clarity options:', error);
      } finally {
        setIsClarityLoading(false);
      }
    };

    fetchClarityOptions();
  }, []);

  useEffect(() => {
    const fetchStoneColors = async () => {
      setIsStoneColorsLoading(true);
      try {
        const response = await axios.get(Constants.listStoneColor);
        if (response.data.status === 1) {
          setStoneColors(response.data.list); // Set stone color options
        }
      } catch (error) {
        console.error('Error fetching stone colors:', error);
      } finally {
        setIsStoneColorsLoading(false);
      }
    };

    fetchStoneColors();
  }, []);

  useEffect(() => {
    const fetchPearlColors = async () => {
      setIsPearlColorsLoading(true);
      try {
        const response = await axios.get(Constants.listPearlColor);
        if (response.data.status === 1) {
          setPearlColors(response.data.list); // Set pearl color options
        }
      } catch (error) {
        console.error('Error fetching pearl colors:', error);
      } finally {
        setIsPearlColorsLoading(false);
      }
    };

    fetchPearlColors();
  }, []);

  useEffect(() => {
    const fetchPearlTypes = async () => {
      setIsPearlTypesLoading(true);
      try {
        const response = await axios.get(Constants.listPearlType);
        if (response.data.status === 1) {
          setPearlTypes(response.data.list); // Set pearl type options
        }
      } catch (error) {
        console.error('Error fetching pearl types:', error);
      } finally {
        setIsPearlTypesLoading(false);
      }
    };

    fetchPearlTypes();
  }, []);

  useEffect(() => {
    const fetchDiamondColors = async () => {
      setIsDiamondColorsLoading(true);
      try {
        const response = await axios.get(Constants.listDiamondColor);
        if (response.data.status === 1) {
          setDiamondColors(response.data.list); // Set diamond color options
        }
      } catch (error) {
        console.error('Error fetching diamond colors:', error);
      } finally {
        setIsDiamondColorsLoading(false);
      }
    };

    fetchDiamondColors();
  }, []);


  const handleChange = (value) => {
    setContent(value);
  };



  const countryOptions = countries.map(country => ({
    value: country.id,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={`${country.country_symbols}`}
          alt={`${country.country} Flag`}
          style={{ width: '20px', marginRight: '10px' }}
        />
        {country.country}
      </div>
    ),
  }));

  const stateOptions = states.map(state => ({ value: state.id, label: state.name }));
  const cityOptions = cities.map(city => ({ value: city.id, label: city.name }));

  const selectionOptions = selections.map((selection) => ({
    value: selection.id,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={`${Constants.imageBaseURL}/${selection.image}`} // Assuming `imageBaseURL` is the base URL for images
          alt={selection.name}
          style={{ width: '20px', marginRight: '10px' }}
        />
        {selection.name}
      </div>
    ),
  }));

  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={`${Constants.imageBaseURL}/${category.image}`} // Assuming `imageBaseURL` is the base URL for images
          alt={category.name}
          style={{ width: '20px', marginRight: '10px' }}
        />
        {category.name}
      </div>
    ),
  }));

  const shopForOptionsMapped = shopForOptions.map((shopFor) => ({
    value: shopFor.id,
    label: shopFor.name,
  }));

  const ringStyleOptionsMapped = ringStyles.map((ringStyle) => ({
    value: ringStyle.id,
    label: ringStyle.name,
  }));

  const stoneColorOptionsMapped = stoneColors.map((stoneColor) => ({
    value: stoneColor.id,
    label: stoneColor.name,
  }));

  const diamondColorOptionsMapped = diamondColors.map((diamondColor) => ({
    value: diamondColor.id,
    label: diamondColor.name,
  }));

  const clarityOptionsMapped = clarityOptions.map((clarity) => ({
    value: clarity.id,
    label: clarity.name,
  }));

  const pearlColorOptionsMapped = pearlColors.map((pearlColor) => ({
    value: pearlColor.id,
    label: pearlColor.name,
  }));

  const pearlTypeOptionsMapped = pearlTypes.map((pearlType) => ({
    value: pearlType.id,
    label: pearlType.name,
  }));

  const handleFileChange = (e) => {
    const files = e.target.files;
    const filesArray = Array.from(files);

    // Create blob URLs for image previews
    const previews = filesArray.map(file => URL.createObjectURL(file));

    setImagePreviews((prevPreviews) => [...prevPreviews, ...previews]);  // Append new previews
    setSelectedFiles((prevFiles) => [...prevFiles, ...filesArray]);  // Append new files
  };


  const [formData, setFormData] = useState({
    country: '',
    state: '',
    city: '',
    selection: '',
    category: '',
    shopFor: '',
    ringStyle: '',
    stoneColor: '',
    diamondColor: '',
    clarity: '',
    pearlColor: '',
    pearlType: '',
    description: '',
    price: ''
  });

  const [fieldErrors, setFieldErrors] = useState({});

  const FieldError = ({ field }) =>
    fieldErrors[field] ? (
      <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
        {fieldErrors[field]}
      </p>
    ) : null;

  useEffect(() => {
    if (product) {
      // setFormData({
      //   idUser: product.idUser,
      //   country: product.idCountry,
      //   state: product.idState,
      //   city: product.idCity,
      //   selection: product.idSelection,
      //   category: product.idCategory,
      //   shopFor: product.idShopFor,
      //   ringStyle: product.idRingStyle,
      //   stoneColor: product.idStoneColor,
      //   diamondColor: product.idDiamondColor,
      //   clarity: product.idClarity,
      //   pearlColor: product.idPearlColor,
      //   pearlType: product.idPearlType,
      //   description: product.description,
      //   price: product.price,
      // });

      setFormData({
        idUser: product.idUser,
        country: product.idCountry,
        state: product.idState,
        city: product.idCity,
        selection: product.idSelection,
        category: product.idCategory,
        shopFor: product.idShopFor,
        ringStyle: product.idRingStyle,
        stoneColor: product.idStoneColor,
        diamondColor: product.idDiamondColor,
        clarity: product.idClarity,
        pearlColor: product.idPearlColor,
        pearlType: product.idPearlType,
        description: product.description,
        price: product.price,
      });

      // 👇 IMPORTANT
      setContent(product.description || "");
      setSelectedSelection(product.idSelection);

      if (product.idCountry) {
        fetchStates(product.idCountry);
      }

      if (product.idState) {
        fetchCities(product.idState);
      }
    }
  }, [product]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    if (!formData.country) errors.country = 'Please select a country.';
    if (!formData.state) errors.state = 'Please select a state.';
    if (!formData.city) errors.city = 'Please select a city.';
    if (!formData.selection) errors.selection = 'Please select a main selection.';
    if ([1, 2, 3, 4, 5, 8].includes(Number(selectedSelection)) && !formData.category) {
      errors.category = 'Please select a category.';
    }
    if (!formData.shopFor) errors.shopFor = 'Please select a shop for option.';
    if (productImages.length === 0 && selectedFiles.length === 0) {
      errors.images = 'Please upload at least one product image.';
    }
    if (!content || content.trim() === '' || content === '<p><br></p>') {
      errors.description = 'Please enter a description.';
    }

    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      setFeedbackMessage('Please fix the highlighted fields below.');
      setFeedbackType('error');
      return;
    }

    setFeedbackMessage('');
    // ---- End validation ----
    const accessToken = localStorage.getItem('authToken');
    const formDataToSubmit = new FormData();
    if (!accessToken) {
      console.error('No access token found');
      return;
    }
    const decodedToken = jwtDecode(accessToken);
    // Assuming the user ID is stored as 'id' in the decoded token
    const idUser = decodedToken.id;
    formDataToSubmit.append('idUser', idUser);
    formDataToSubmit.append('idCountry', formData.country);
    formDataToSubmit.append('idState', formData.state);
    formDataToSubmit.append('idCity', formData.city);
    formDataToSubmit.append('idSelection', formData.selection);
    // formDataToSubmit.append('idCategory', formData.category);
    if (formData.category) {
      formDataToSubmit.append('idCategory', formData.category);
    }
    if (formData.shopFor) formDataToSubmit.append('idShopFor', formData.shopFor);
    if (formData.ringStyle) formDataToSubmit.append('idRingStyle', formData.ringStyle);
    if (formData.stoneColor) formDataToSubmit.append('idStoneColor', formData.stoneColor);
    if (formData.diamondColor) formDataToSubmit.append('idDiamondColor', formData.diamondColor);
    if (formData.clarity) formDataToSubmit.append('idClarity', formData.clarity);
    if (formData.pearlColor) formDataToSubmit.append('idPearlColor', formData.pearlColor);
    if (formData.pearlType) formDataToSubmit.append('idPearlType', formData.pearlType);
    if (content) formDataToSubmit.append('description', content);

    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formDataToSubmit.append('images', file); // Append each file to the FormData
      });
    }
    try {
      // const response = await axios.put(`${Constants.editProduct}/${id}`, formDataToSubmit, {
      //   headers: {
      //     Authorization: `Bearer ${accessToken}`,
      //     'Content-Type': 'multipart/form-data',
      //   },
      // });

      const response = await axios.put(`${Constants.editProduct}/${id}`, formDataToSubmit);


      if (response.data.success === 1) {
        setFeedbackMessage('Product updated successfully!');
        setFeedbackType('success');
        setSelectedFiles([]);
        setImagePreviews([]);
        setIsLoading(false);
      } else {
        setFeedbackMessage('Failed to update product.');
        setFeedbackType('error');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error creating product:', error);
      setFeedbackMessage('An error occurred while creating the product.');
      setFeedbackType('error'); // Set feedback type to error
    }
  };

  const handleDeleteImage = async (imageId) => {
    try {
      const response = await axios.delete(`${Constants.deleteProductImagesById}/${imageId}`);

      if (response.data.status === 1) {
        // Remove from UI
        setProductImages(prevImages => prevImages.filter(img => img.id !== imageId));
      } else {
        console.error('Failed to delete image:', response.data.message);
      }
    } catch (error) {
      console.error('Error deleting image:', error);
    }
  };


  return (
    <>
      <Breadcumb pagetitle="Edit Product" />
      <section className='dashboardsec'>
        <div className='container mx-auto px-4'>
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              {feedbackMessage && (
                <div
                  style={{
                    marginTop: "16px",       // mt-4
                    padding: "16px",         // p-4
                    textAlign: "center",     // text-center
                    borderRadius: "6px",     // rounded-md
                    backgroundColor: feedbackType === 'success' ? "#D1FAE5" : "#FEE2E2", // green-100 / red-100
                    color: feedbackType === 'success' ? "#047857" : "#B91C1C",           // green-700 / red-700
                  }}
                >
                  {feedbackMessage}
                </div>
              )}
              <form className="form-profile" key={resetKey} onSubmit={handleSubmit}>
                <h2 className='text-3xl font-bold headningfont mb-5'>Update Product </h2>
                <Grid container spacing={3}>
                  {/* Country, State, City Selections */}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>Country <span className='text-red-500'>*</span></label>
                    <Select
                      options={countryOptions}
                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, country: option.value, state: '', city: '' }));
                        fetchStates(option.value);
                      }}
                      value={countryOptions.find((option) => option.value === formData.country)}
                      placeholder="Select Country"
                      isSearchable
                    />
                    <FieldError field="country" />
                  </Grid>
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>State <span className='text-red-500'>*</span></label>
                    <Select
                      options={stateOptions}
                      value={stateOptions.find((option) => option.value === formData.state) || null}
                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, state: option.value, city: '' }));
                        fetchCities(option.value);
                      }}
                      placeholder="Select State"
                      isSearchable
                    />
                    <FieldError field="state" />

                  </Grid>
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>City <span className='text-red-500'>*</span></label>
                    <Select
                      options={cityOptions}
                      value={cityOptions.find((option) => option.value === formData.city) || null}
                      onChange={(option) => setFormData((prev) => ({ ...prev, city: option.value }))}
                      placeholder="Select City"
                      isSearchable
                    />
                    <FieldError field="city" />
                  </Grid>

                  {/* Main Selection (Dynamic Dropdown) */}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className="mb-3 block font-semibold">
                      Main Selection <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={selectionOptions}
                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, selection: option.value }));
                        setSelectedSelection(option.value);
                      }}
                      value={selectionOptions.find((option) => option.value === formData.selection) || null} // Pre-select the main selection
                      placeholder="Select Main Selection"
                      isSearchable
                    />
                    <FieldError field="selection" />
                  </Grid>
                  {selectedSelection == 1 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                        <FieldError field="category" />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                        <FieldError field="shopFor" />
                      </Grid>
                    </>
                  )}


                  {selectedSelection == 4 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}

                  {selectedSelection == 2 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>


                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Ring Style <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={ringStyleOptionsMapped}
                          value={ringStyleOptionsMapped.find((option) => option.value === formData.ringStyle) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, ringStyle: option.value }))}
                          placeholder="Select Ring Style"
                          isSearchable
                          isLoading={isRingStylesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Diamond Color <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={diamondColorOptionsMapped}
                          value={diamondColorOptionsMapped.find((option) => option.value === formData.diamondColor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, diamondColor: option.value }))}
                          placeholder="Select Diamond Color"
                          isSearchable
                          isLoading={isDiamondColorsLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Clarity <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={clarityOptionsMapped}
                          value={clarityOptionsMapped.find((option) => option.value === formData.clarity) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, clarity: option.value }))}
                          placeholder="Select Clarity"
                          isSearchable
                          isLoading={isClarityLoading}
                        />
                      </Grid> */}

                    </>
                  )}

                  {selectedSelection == 8 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>

                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Ring Style <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={ringStyleOptionsMapped}
                          value={ringStyleOptionsMapped.find((option) => option.value === formData.ringStyle) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, ringStyle: option.value }))}
                          placeholder="Select Ring Style"
                          isSearchable
                          isLoading={isRingStylesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Stone Color <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={stoneColorOptionsMapped}
                          value={stoneColorOptionsMapped.find((option) => option.value === formData.stoneColor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, stoneColor: option.value }))}
                          placeholder="Select Stone Color"
                          isSearchable
                          isLoading={isStoneColorsLoading}
                        />
                      </Grid> */}
                    </>
                  )}

                  {selectedSelection == 5 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>

                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Pearl Color <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={pearlColorOptionsMapped}
                          value={pearlColorOptionsMapped.find((option) => option.value === formData.pearlColor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, pearlColor: option.value }))}
                          placeholder="Select Pearl Color"
                          isSearchable
                          isLoading={isPearlColorsLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Pearl Type <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={pearlTypeOptionsMapped}
                          value={pearlTypeOptionsMapped.find((option) => option.value === formData.pearlType) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, pearlType: option.value }))}
                          placeholder="Select Pearl Type"
                          isSearchable
                          isLoading={isPearlTypesLoading}
                        />
                      </Grid> */}
                    </>
                  )}


                  {selectedSelection == 3 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}

                  {selectedSelection == 7 && (
                    <>
                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={categoryOptions.find((option) => option.value === formData.category) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, category: option.value }))}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid> */}

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}

                  {selectedSelection == 6 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          value={shopForOptionsMapped.find((option) => option.value === formData.shopFor) || null}
                          onChange={(option) => setFormData((prev) => ({ ...prev, shopFor: option.value }))}
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}


                  {/* Product Image Upload */}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label
                      style={{
                        marginBottom: "12px",
                        display: "block",
                        fontWeight: "600",
                      }}
                    >
                      Product Images <span style={{ color: "red" }}>*</span>
                    </label>

                    <div style={{ marginBottom: "8px" }}>
                      <label
                        style={{
                          width: "120px",
                          height: "100px",
                          border: "1px solid #ddd",
                          padding: "16px 8px",
                          borderRadius: "8px",
                          textAlign: "center",
                          display: "inline-block",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          multiple
                        />

                        <i
                          className="fa-solid fa-camera"
                          style={{
                            fontSize: "40px",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        ></i>

                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6B7280",
                          }}
                        >
                          Browse Files...
                        </p>
                      </label>
                    </div>

                    {/* Display default (existing) images from DB */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginTop: "8px",
                      }}
                    >
                      {productImages.map((image, index) => (
                        <div
                          key={`existing-${index}`}
                          style={{
                            position: "relative",
                          }}
                        >
                          <img
                            src={`${Constants.imageBaseURL}/${image.image}`}
                            alt={`Existing ${index}`}
                            style={{
                              width: "96px",
                              height: "96px",
                              objectFit: "cover",
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                            }}
                          />

                          <button
                            type="button"
                            onClick={() => handleDeleteImage(image.id)}
                            title="Delete Image"
                            style={{
                              position: "absolute",
                              top: "-8px",
                              right: "-8px",
                              backgroundColor: "#EF4444",
                              color: "#fff",
                              borderRadius: "50%",
                              width: "24px",
                              height: "24px",
                              border: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}

                      {/* Display newly selected previews */}
                      {imagePreviews.map((preview, index) => (
                        <div
                          key={`new-${index}`}
                          style={{
                            position: "relative",
                          }}
                        >
                          <img
                            src={preview}
                            alt={`Preview ${index}`}
                            style={{
                              width: "96px",
                              height: "96px",
                              objectFit: "cover",
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginTop: "4px",
                      }}
                    >
                      Image Type: (W: 800px, H: 1100px) PNG, JPEG, JPG
                    </p>
                  </Grid>
                  {/* Description Editor */}
                  {/* <Grid item lg={10} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>Description <span className='text-red-500'>*</span></label>
                    <ReactQuill theme="snow" value={content} onChange={handleChange} className='h-[180px] mb-8' />
                  </Grid> */}
                  <Grid item lg={10} md={6} sm={12} xs={12}>
                    <label
                      style={{
                        marginBottom: "12px",
                        display: "block",
                        fontWeight: "600"
                      }}
                    >
                      Description <span style={{ color: "red" }}>*</span>
                    </label>

                    <div
                      style={{
                        height: "180px",
                        marginBottom: "32px"
                      }}
                    >
                      <ReactQuill
                        theme="snow"
                        value={content}
                        onChange={handleChange}
                        style={{
                          height: "140px"
                        }}
                      />
                    </div>
                  </Grid>

                  {/* Submit Button */}
                  <Grid item lg={10} md={6} sm={12} xs={12}>
                    <button className="inline-block submit_btn h-14 px-8 border rounded bg-[#b3902d] min-w-32 text-white font-semibold">Publish</button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
}